import React, { useEffect } from 'react'
import logo from '../logo.png';
import { Loading } from '../components/Loading';
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from 'react-router-dom';

export default function AuthLayout({ children, title }) {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, [])

  return (
    <>
    <Loading />
      <section className="h-screen pb-16 gradient-bg w-full px-6 md:px-0 pt-36  overflow-scroll flex flex-col justify-center items-center gap-0 relative">
        <div className="lg:w-1/3 md:w-3/5 w-full bg-white py-8 rounded-lg lg:px-12 px-8" data-aos="zoom-in">
          <div className="mb-6 flex md:justify-start justify-center md:items-start items-center flex-col ">
            <Link to="/">
              <div className="relative w-fit">
                <img src={logo} className="h-8 mb-3" alt="Logo" />
                <span className="font-semibold text-3xl absolute -top-2 xl:-right-4 -right-4">&reg;</span>
              </div>
            </Link>
            <h1 className="font-semibold text-2xl font-fira">{title}</h1>
          </div>
          {children}
        </div>

      </section>
    </>
  )
}
